import React, { createContext, useContext, useState, useEffect } from 'react';
import {HOST} from "../utils/vars";
import axios from "axios";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  axios.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  // Проверка и обновление токена при загрузке
  useEffect(() => {
    setLoading(true);
    const checkAuth = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`${HOST}/api/v1/refresh`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
        // console.log(res);
        const data = await res.json();
        if (res.ok) {
          localStorage.setItem('token', data.accessToken);
          const payload = JSON.parse(atob(data.accessToken.split('.')[1]));
          setUser({ id: payload.id, role: payload.role, username: payload.username });
        } else {
          setUser(null);
        }
      } catch (err) {
        // console.error(err);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const login = async (username, password) => {
    setLoading(true);
    const res = await fetch(`${HOST}/api/v1/login`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ username, password })
    });

    const data = await res.json();
    setLoading(false);
    if (res.ok) {
      localStorage.setItem('token', data.accessToken);
      const payload = JSON.parse(atob(data.accessToken.split('.')[1]));
      setUser({ id: payload.id, role: payload.role, username: payload.username });
      // без navigate
    } else {
      throw new Error(data.message || 'Ошибка авторизации');
    }
  };

  const logout = async () => {
    await fetch(`${HOST}/api/v1/logout`, {
      method: 'POST',
      credentials: 'include'
    });
    localStorage.removeItem('token');
    setUser(null);
    // без navigate
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
